import React, { useMemo } from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceTestType } from "@intelligems/ig-types";
import { SpeedOutlined } from "@mui/icons-material";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { Box, Grid } from "@mui/material";

import { AudienceTargetingBlueIcon } from "../../../../images/Icons/AudienceTargetingBlueIcon";
import { CompleteSolutionIcon } from "../../../../images/Icons/CompleteSolution";
import { PageTargetingIconBlue } from "../../../../images/Icons/PageTargetingIconBlue";
import { PriceTagIcon } from "../../../../images/Icons/PriceTag";
import { RevenueUpliftIcon } from "../../../../images/Icons/RevenueUpliftIcon";
import { ShippingTestIcon } from "../../../../images/Icons/ShippingTest/ShippingTestIcon";
import { ThinRoiIcon } from "../../../../images/Icons/ThinRoi";
import { UrlIconBlue } from "../../../../images/Icons/UrlIconBlue";
import { UtmIconBlue } from "../../../../images/Icons/UtmIconBlue";
import theme from "../../../../theme";

interface SelectedTestTypeProps {
  selectedTestType: ExperienceTestType | "";
  handleNext: () => void;
}
const campaignDescriptions = [
  {
    text: "Target specific customers and channels for your promos",
    icon: <AudienceTargetingBlueIcon sx={{ fontSize: "40px" }} />,
  },
  {
    text: "Boost offer effectiveness and increase AOV through elevated offers like volume discounts, gift with purchase, and bundles",
    icon: <ThinRoiIcon sx={{ fontSize: "40px" }} />,
  },
  {
    text: "Create auto-applied discounts that don’t use leak-able promo codes",
    icon: <PriceTagIcon sx={{ fontSize: "40px" }} />,
  },
  {
    text: "A/B test your offers and measure which ones are more effective and profitable",
    icon: <CompleteSolutionIcon sx={{ fontSize: "40px" }} />,
  },
];

const contentDescriptions = [
  {
    text: "Test copy and imagery changes with the Intelligems visual builder",
    icon: <PageTargetingIconBlue sx={{ fontSize: "40px" }} />,
  },
  {
    text: "Measure the impact of a theme redesign with theme testing",
    icon: <UtmIconBlue sx={{ fontSize: "40px" }} />,
  },
  {
    text: "Test versions of a page with URL redirection",
    icon: <UrlIconBlue sx={{ fontSize: "40px" }} />,
  },
  {
    text: "Build custom experiences with the Intelligems Javascript API",
    icon: (
      <HandymanOutlinedIcon
        sx={{ fontSize: "40px", color: theme.palette.primary.main }}
      />
    ),
  },
];
const priceDescriptions = [
  {
    text: "Test higher and lower product prices to measure price elasticity",
    icon: (
      <SpeedOutlined
        sx={{ fontSize: "40px", color: theme.palette.primary.main }}
      />
    ),
  },
  {
    text: "Experiment with using Strikethrough pricing to boost conversion rate",
    icon: <RevenueUpliftIcon sx={{ fontSize: "36px" }} />,
  },
];
const shippingDescription = [
  {
    text: "Find the right free shipping threshold that boosts AOV without harming conversion",
    icon: (
      <VerifiedOutlinedIcon
        sx={{ fontSize: "40px", color: theme.palette.primary.main }}
      />
    ),
  },
  {
    text: "Find out what shipping rates your customers are willing to pay",
    icon: <ShippingTestIcon sx={{ fontSize: "40px" }} />,
  },
];
export const SelectedTestType = ({
  selectedTestType,
  handleNext,
}: SelectedTestTypeProps) => {
  const renderDescription = useMemo(() => {
    return selectedTestType === "content"
      ? contentDescriptions
      : selectedTestType === "campaign"
        ? campaignDescriptions
        : selectedTestType === "pricing"
          ? priceDescriptions
          : shippingDescription;
  }, [selectedTestType]);

  return (
    <Grid
      container
      direction={"column"}
      item
      alignItems={"center"}
      rowSpacing={2}
    >
      <Grid item container direction={"row"} rowSpacing={2} columnSpacing={1}>
        {renderDescription.map((x, index) => (
          <Grid key={index} item xs={6}>
            <Box
              sx={{
                borderRadius: "15px",
                padding: "15px",
                height: "70px",
              }}
            >
              <Grid item container direction={"row"}>
                <Grid item xs={2}>
                  <>{x.icon}</>
                </Grid>
                <Grid item xs={10}>
                  <IgTypography sx={{ fontWeight: 500 }}>{x.text}</IgTypography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid item>
        <IgButton
          onClick={handleNext}
          sx={{ fontSize: "16px", width: "215px" }}
          variant={"contained"}
        >
          Continue
        </IgButton>
      </Grid>
    </Grid>
  );
};
